import { useEffect, useMemo, useRef, useState } from "react";
import { Color, MathUtils, PointLight, Vector3 } from "three";
import { useObjectCallback, useSheet } from "../../../hooks/useTheatre";
import { findObjectStartsWithKey } from "../../../utils/FindObjects";
import HardeningTemperingUI from "../../ui/Sections/Applications/HardeningTemperingUI";
import CanvasUiContainer from "../CanvasUiContainer";
import RinginductorWater from "../products/hardline/RinginductorWater";
import SteamParticlesInstances from "../products/hardline/SteamParticelsBAS";
import { CircularWaterStreams } from "../products/hardline/Water";
import MeasureLabel from "./MeasureLabel";
import store from "../../../appStore";
import { SideBarHider } from "../../ui/SideBar/SideBar";

const LightName = "HardeningTempering_Light_asdfadsfadsf";

const HardeningTemperingProcess = ({
  action,
  // measureData,
  workpiece,
  heatSource,
  scene,
  root,
  ...props
}) => {
  const sheet = useSheet("EFD", "HARDENING_TEMPERING_PROCESS", "0");

  const label1Ref = useRef();
  const label2Ref = useRef();
  const uiRef = useRef();

  const waterRef = useRef();
  const waterRef2 = useRef();
  const waterTubeRef = useRef();

  const particlesRef = useRef();
  const [steam1active, setsteam1active] = useState(false);
  const steam1activeRef = useRef(false);

  const measureData = useMemo(() => {
    var labels = [];
    var hsParent;
    hsParent = findObjectStartsWithKey("Labels_Measures", scene);
    hsParent.children.forEach((c) => labels.push(c));

    return labels;
  }, [scene]);

  const animationConfig = useMemo(() => {
    return {
      animationTime: 0,
      heatIntesity: 0,
      label1: 0,
      label2: 0,
      hardened: 1,
      lightIntesity: 0,
      steam1: false,
      water: 0,
    };
  }, []);

  const heatSourceWorldPosition = useMemo(() => {
    return new Vector3();
  }, []);

  const Light = useMemo(() => {
    var l = findObjectStartsWithKey(LightName, scene);
    if (l) return l;

    var target = heatSource;

    var light = new PointLight(new Color("#ff0000"), 0);

    // light.add(debugSphere);
    light.position.copy(target.position);
    light.name = LightName;
    light.distance = 2.5;
    light.decay = 1;
    target.add(light);
    light.position.copy(new Vector3());

    return light;
  }, []);

  useObjectCallback(
    sheet,
    "Animation",
    animationConfig,
    ({ animationTime, heatIntesity, label1, label2, hardened, lightIntesity, steam1, water }) => {
      action.time = sheet.sequence.position;

      if (Light) {
        Light.intensity = lightIntesity;
      }

      if (steam1activeRef.current != steam1) {
        steam1activeRef.current = steam1;
        setsteam1active(steam1);
      }

      heatSource.getWorldPosition(heatSourceWorldPosition);

      if (workpiece.material.userData.shader) {
        workpiece.material.userData.shader.uniforms.uHeatSource.value = heatSourceWorldPosition;

        workpiece.material.userData.shader.uniforms.uHeat.value = heatIntesity;
        workpiece.material.userData.shader.uniforms.uHardened.value = hardened;
      }

      // heatSourceWorldPosition.applyMatrix4(root.worldMatrix);

      if (particlesRef.current) {
        particlesRef.current.position.copy(heatSourceWorldPosition);
        // particlesRef.current.applyMatrix4(root.matrixWorld);
      }

      if (label1Ref.current) {
        label1Ref.current.fadeIn(label1);
        label2Ref.current.fadeIn(label2);
      }
      if (uiRef.current) {
        uiRef.current.loading(animationTime * 100 + "%");
      }

      if (waterRef.current) {
        waterRef.current.scale.x = water;
        waterRef.current.scale.y = water;
        waterRef.current.scale.z = water;

        waterRef2.current.scale.x = water;
        waterRef2.current.scale.y = water;
        waterRef2.current.scale.z = water;
      }

      if (waterTubeRef.current) {
        waterTubeRef.current.material.uniforms.uFadeIn.value = water * 0.2;
      }
    },
  );

  useEffect(() => {
    action.reset().play().fadeIn(0.5);
    action.play();
    action.paused = true;
    sheet.sequence.position = 0;
    sheet.sequence.play({ iterationCount: Infinity });
    return () => {
      sheet.sequence.position = 0;
      sheet.sequence.pause();
      action.time = 0;
      action.fadeOut(0.5);
    };
  }, []);

  return (
    <group>
      {/* <MeasureLabel
        label={measureData[0]}
        instanceName={`Label_${0}`}
        textid={"L4_HARDENING_PROPERTY_A"}
        ref={label1Ref}
      />
      <MeasureLabel
        label={measureData[1]}
        instanceName={`Label_${1}`}
        textid={"L4_HARDENING_PROPERTY_B"}
        ref={label2Ref}
      /> */}
      <SideBarHider />

      <group position={[-root.position.x, -root.position.y, -root.position.z]}>
        <group ref={particlesRef}>
          <group scale={10}>
            <SteamParticlesInstances active={steam1active} particleCount={20} lifetime={8} />
          </group>
          <group ref={waterRef}>
            <CircularWaterStreams scale={6} position={[0.0, -0.1, 0]} />
          </group>
          <group ref={waterRef2} position={[0.0, -0.3, 0]}>
            <CircularWaterStreams scale={6} />
          </group>
          <RinginductorWater ref={waterTubeRef} scale={10} position={[0.0, -1.8, -0]} />
        </group>
      </group>

      <CanvasUiContainer>
        <HardeningTemperingUI ref={uiRef} />
      </CanvasUiContainer>
    </group>
  );
};

export default HardeningTemperingProcess;
